var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uploader-wrapper"},[_c('toast-container',{attrs:{"toastConfig":_vm.toastConfig}}),_c('div',{staticClass:"uploader-container"},[(!_vm.store__loginState.isLoggedIn)?_c('Login'):_c('Dashboard')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }